import script from "./LandingCenterCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingCenterCard.vue?vue&type=script&setup=true&lang=js"

import "./LandingCenterCard.vue?vue&type=style&index=0&id=35404736&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35404736"]])

export default __exports__